export enum ChecklistComplementaryItemPosition {
  Ground = 'vehicle_on_the_ground',
  Lift = 'vehicle_on_lift',
  TestRun = 'final_inspection_and_test_run',
}

export const checklistComplementaryItems = [
  {
    value:
      'domain.enums.checklist_complementary_items.check_fault_codes_via_scanner',
    position: ChecklistComplementaryItemPosition.Ground,
    label: 'Verificar códigos de falhas via scanner',
  },
  {
    value: 'domain.enums.checklist_complementary_items.check_latest_revision',
    position: ChecklistComplementaryItemPosition.Ground,
    label: 'Checar última revisão (Ex: Velas, Filtros, Oléo, Correias)',
  },
  {
    value: 'domain.enums.checklist_complementary_items.brake_and_servobrake',
    position: ChecklistComplementaryItemPosition.Ground,
    label: 'Freio e Servofreio',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.brake_booster_check_valve_hose_and_engine_intake_manifold',
    position: ChecklistComplementaryItemPosition.Ground,
    label:
      'Válvula de retenção do servofreio, mangueira e coletor de admissão do motor',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.adjust_windshield_and_rear_window_wiper_arms',
    position: ChecklistComplementaryItemPosition.Ground,
    label: 'Ajustar braços dos limpadores de parabrisa e do vidro traseiro',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.effort_on_the_clutch_pedal',
    position: ChecklistComplementaryItemPosition.Ground,
    label: 'Esforço no pedal da embreagem',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.seat_belts_and_fastening',
    position: ChecklistComplementaryItemPosition.Ground,
    label: 'Cintos de segurança e fixação',
  },
  {
    value: 'domain.enums.checklist_complementary_items.cabin_filter',
    position: ChecklistComplementaryItemPosition.Ground,
    label: 'Filtro de cabine',
  },
  {
    value: 'domain.enums.checklist_complementary_items.headlight_adjustment',
    position: ChecklistComplementaryItemPosition.Ground,
    label: 'Ajuste de faróis',
  },
  {
    value: 'domain.enums.checklist_complementary_items.check_mirrors',
    position: ChecklistComplementaryItemPosition.Ground,
    label: 'Verificar retrovisores',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.springs_and_shock_absorbers',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Molas e amortecedores',
  },
  {
    value: 'domain.enums.checklist_complementary_items.exhaust_system',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Sistema de escapamento (oxidação, vazamento, fixação, etc.)',
  },
  {
    value: 'domain.enums.checklist_complementary_items.catalyst',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Catalisador',
  },
  {
    value: 'domain.enums.checklist_complementary_items.fuel_filter',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Filtro de combustível',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.leaks_in_fuel_system_hoses_and_fittings',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Vazamentos em mangueiras e fixações do sistema de combustível',
  },
  {
    value: 'domain.enums.checklist_complementary_items.body_condition',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Condições da carroceria (suportes estruturais)',
  },
  {
    value: 'domain.enums.checklist_complementary_items.wheel_bearing_play',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Folga dos rolamentos de rodas',
  },
  {
    value: 'domain.enums.checklist_complementary_items.brake_discs_and_pads',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Discos e pastilhas de freio',
  },
  {
    value: 'domain.enums.checklist_complementary_items.brake_drums_and_linings',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Tambores e lonas de freio',
  },
  {
    value: 'domain.enums.checklist_complementary_items.brake_hydraulic_system',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Sistema hidráulico do freio (cilindros, pinças e flexíveis)',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.leakage_in_the_brake_pressure_equalizing_valve',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Vazamento na válvula equalizadora de pressão dos freios',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.parking_brake_cables_and_rods',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Cabos e hastes do freio de estacionamento',
  },
  {
    value: 'domain.enums.checklist_complementary_items.electric_cables',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Cabos elétricos (cabos dos sensores do ABS, etc.)',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.check_gearbox_oil_and_leaks',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Verificar óleo da caixa de câmbio e vazamentos',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.steering_system_components_and_leaks',
    position: ChecklistComplementaryItemPosition.Lift,
    label:
      'Componentes do sistema de direção (caixa, coifas, terminais, etc.) e vazamentos',
  },
  {
    value: 'domain.enums.checklist_complementary_items.cv_hoods',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Coifas da homocinéticas',
  },
  {
    value: 'domain.enums.checklist_complementary_items.leaks_in_the_gearbox',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Vazamentos na caixa de marcha',
  },
  {
    value: 'domain.enums.checklist_complementary_items.tray_bushings',
    position: ChecklistComplementaryItemPosition.Lift,
    label: 'Buchas da bandeja',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.what_the_customer_initially_complained_about_was_done',
    position: ChecklistComplementaryItemPosition.TestRun,
    label: 'Foi feito o que o cliente reclamou inicialmente',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.fill_in_labels_manual_system_history',
    position: ChecklistComplementaryItemPosition.TestRun,
    label: 'Preencher etiquetas, manual, histórico no sistema, etc',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.reset_maintenance_interval_indicator',
    position: ChecklistComplementaryItemPosition.TestRun,
    label: 'Zerar indicador do intervalo de manutenção',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.check_tighten_wheel_nuts_and_bolts',
    position: ChecklistComplementaryItemPosition.TestRun,
    label: 'Verificar / apertar porcas e parafusos de roda',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.check_gaskets_seals_suspension_covers',
    position: ChecklistComplementaryItemPosition.TestRun,
    label: 'Verificar juntas, vedações, tampas da suspensão',
  },
  {
    value: 'domain.enums.checklist_complementary_items.reservoir_caps_in_order',
    position: ChecklistComplementaryItemPosition.TestRun,
    label: 'Tampas dos reservatórios em ordem',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.check_steering_clearance',
    position: ChecklistComplementaryItemPosition.TestRun,
    label: 'Verificar folga de direção',
  },
  {
    value: 'domain.enums.checklist_complementary_items.gearbox_gear_shifting',
    position: ChecklistComplementaryItemPosition.TestRun,
    label: 'Caixa de câmbio / troca de marchas',
  },
  {
    value:
      'domain.enums.checklist_complementary_items.instrument_and_control_panel',
    position: ChecklistComplementaryItemPosition.TestRun,
    label: 'Painel de instrumentos e de controle',
  },
  {
    value: 'domain.enums.checklist_complementary_items.brake_system',
    position: ChecklistComplementaryItemPosition.TestRun,
    label:
      'Sistema de freio – assentamento em caso de troca de pastilha e lona',
  },
  {
    value: 'domain.enums.checklist_complementary_items.vehicle_is_clean',
    position: ChecklistComplementaryItemPosition.TestRun,
    label: 'Veículo está limpo',
  },
];
